CLASSIC_FACET_RECIPE_TYPE